import { Container, type ContainerProps } from '@mui/material';
import { headerHeight } from '@/components/layout/header/constants/header-height';

type PageContainerProps = ContainerProps & {
  noGutter?: boolean;
};

export const PageContainer = ({ children, noGutter = false, ...props }: PageContainerProps) => {
  const { maxWidth, sx, ...rest } = props;

  const paddingTop = `${noGutter ? headerHeight : headerHeight + 24}px`;

  return (
    <Container
      maxWidth={maxWidth ?? 'lg'}
      sx={{
        mb: 10,
        overflow: 'hidden',
        pt: paddingTop,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Container>
  );
};
